import React from 'react';
import './Modal.css';

const Modal = ({ imgSrc, altText, closeModal }) => {
    return (
        <div className="Gallery-modal-overlay" onClick={closeModal}>
            <div className="gallery-modal-content" onClick={(e) => e.stopPropagation()}>
                <img src={imgSrc} alt={altText} />
                <button className="gallery-close-modal-btn" onClick={closeModal}>X</button>
            </div>
        </div>
    );
};

export default Modal;
